export default __webpack_public_path__ + "static/media/Group 9.97e0ff0d.png";